// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "root-22AIW";
var _4 = "prices-2hK7V";
var _5 = "row-26DUK";
var _6 = "row_total-2Xo5s";
var _7 = "label-2aUIs";
var _8 = "money-1xWPU";
export { _1 as "__esModule", _2 as "mobile", _3 as "root", _4 as "prices", _5 as "row", _6 as "row_total", _7 as "label", _8 as "money" }
export default { "__esModule": _1, "mobile": _2, "root": _3, "prices": _4, "row": _5, "row_total": _6, "label": _7, "money": _8 }
